var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "matrix(-1 0 0 1 32 0)",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_45_643",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_45_643",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAzFJREFUWEfVlk1IVFEUx//n6UukrJlxkYtAaRHRGFQILdw04TvTqkxoKIg2LSqLEkkIaTG7voiIiJBwFRUNSU4LmfeuYW2eG4VKqcRcRBFtRtHc+DFz4sYTREeb9wSlWc6ce/+/e/7nYwgb/KEN1sf/C5BKpTaFw+FGEWkkogMiskNnk4h+5PP5QcMw0hMTE92JRGJ2tSwHyoBSqklE7gDYudrlIjJGRG3M/GqlOF8AyWTSqK+vvykibfpCEfkIoLOkpKQ3l8t9876rMQyjAcBZAHs94Vuu67Ynk8n8UhBfAEqp2574DIArrus+LnSpFvFgz4nIPQBlAG4x87XAAF7auwBo8Tgzvyumg5RSh0QkoyFE5Hg8Hu9efK6oDOiCC4VCnz3PzzNzRzHiCzG2bTcT0UMAXyORyJ66urq5hd+KAlBKJUTkhfa8v79//0ppXwkqlUqVhEKh9wBqReREPB5/6QvAcZznAE4S0WXLsh74ef1CrFKqRdcDET21LOu0X4ARALsMw4g2NDR8CgKQyWSihmEME9GIZVm7/QL8BrDFNM2KWCw2HQQgnU5XlJeXTwGYZuYKvwBadPNaAHp6eraWlpZOAphi5m1+AcZ0B6zFAtu2a4loKKgFzwCcAtDCzPeDWOA4TiuAuwCeMPMZXxmwbVt3gO6EIdd19wVsww8AooHacGBgwBwfHx8FUE1EzZZlPfKTBaXUJRHR7TsaiUSivgeRFlNKHRMRPUZniOiIZVlvi4HIZDIxwzD0KDYBNDLza9+jWB/o6+urmpubGwZQqSFEpHVycrIjkUjkCoHo6RcOhy+IiPZ9E4AbzNweaBl54n0A9ADJehD6Lj1YOnO5nCorK/u7jmdnZ2sAWESk13FUb20AN13XvR5oHS8R/2KaZmx+fv6giOhuqP6HDbpuri5Ne9EWFBKPxWK/9AW6MLPZbBOAowAOElGV99rvAAZFJF1ZWZleXHCFYFfchr29vdvz+fwbnUY9PETkMDP/LKbw/MQUBFgvcQ26DGA9xZcBrLf4MoBFE+tvtS8UnB9P/cYus8BxnIumaXath3jBGvD7grXGF/WndK0iq53fcIA/o76KMANxmcQAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.43ab9315531fa4d026d8eaff55ea14e9.svg";
export { ForwardRef as ReactComponent };